import { render, staticRenderFns } from "./成交公告详情.vue?vue&type=template&id=1605c85f&scoped=true"
import script from "./成交公告详情.vue?vue&type=script&lang=js"
export * from "./成交公告详情.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605c85f",
  null
  
)

export default component.exports